import { render, staticRenderFns } from "./TestAPI.vue?vue&type=template&id=35ea97c4"
import script from "./TestAPI.vue?vue&type=script&lang=js"
export * from "./TestAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports